/**
 * @GENERATED from Figma node 693:15988
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const FigmaBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#0ACF83"
      d="M8.5 22c1.932 0 3.5-1.494 3.5-3.334v-3.333H8.5c-1.932 0-3.5 1.493-3.5 3.333S6.568 22 8.5 22"
    />
    <path
      fill="#1ABCFE"
      d="M19 12.167c0 1.932-1.568 3.5-3.5 3.5a3.5 3.5 0 0 1-3.5-3.5c0-1.932 1.568-3.5 3.5-3.5s3.5 1.568 3.5 3.5"
    />
    <path
      fill="#A259FF"
      d="M5 12c0-1.84 1.568-3.333 3.5-3.333H12v6.666H8.5C6.568 15.333 5 13.84 5 12"
    />
    <path
      fill="#FF7262"
      d="M12 2h3.5C17.432 2 19 3.493 19 5.333s-1.568 3.334-3.5 3.334H12z"
    />
    <path
      fill="#F24E1E"
      d="M5 5.333C5 3.493 6.568 2 8.5 2H12v6.667H8.5C6.568 8.667 5 7.173 5 5.333"
    />
  </svg>
);
const ForwardRef = React.forwardRef(FigmaBright);
export { ForwardRef as FigmaBright };
